import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2;

import { mergeSxProps } from '@infl-ts/util-merge-sx-props';
import RedeemIcon from '@mui/icons-material/Redeem';
import { Box, Chip, styled, Typography } from '@mui/material';
import ReactAspectRatio from 'react-aspect-ratio';
import { Translation, useTranslation } from 'react-i18next';
import { CloudflareImage } from '../cloudflare-image';
import { formatPoints, Points } from '../points';
import { ProgressBar } from '../progress-bar';
import { ResizableCard } from '../resizable-card';
import { RewardRedemption } from '../reward-redemption';
import { RouterLink } from '../router-link';
import { Tooltip } from '../tooltip';
import { TypographyTruncate } from '../typography-truncate';
import GiftFallback from './gift-icon';
import WishlistButton from './wishlist-button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Content = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  padding: ", ";\n  padding-top: ", ";\n  height: 140px;\n"])), function (p) {
  return p.theme.spacing(2);
}, function (p) {
  return p.theme.spacing(0.5);
});
export var FullCardLink = styled(RouterLink)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: inherit;\n  text-decoration: none;\n\n  &:before {\n    content: ' ';\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n  }\n\n  &:hover {\n    text-decoration: none;\n  }\n"])));

var CardImage = function CardImage(_ref) {
  var image = _ref.image,
      name = _ref.name;
  return /*#__PURE__*/_jsx(ReactAspectRatio, {
    ratio: "3/2",
    style: {
      maxWidth: 'auto',
      margin: 'auto'
    },
    "data-element": "ReactAspectRatio",
    "data-component": "CardImage",
    "data-source-file": "reward-card.tsx",
    children: image ? /*#__PURE__*/_jsx(CloudflareImage, {
      id: image.id,
      blurhash: image.blurhash,
      alt: name
    }) : /*#__PURE__*/_jsx(GiftFallback, {})
  });
};

export var Coins = function Coins(_ref2) {
  var points = _ref2.points;
  return /*#__PURE__*/_jsx(Points, {
    sx: {
      mr: 0.5
    },
    points: points,
    "data-element": "Points",
    "data-component": "Coins",
    "data-source-file": "reward-card.tsx"
  });
};

var CoinsWithTooltip = function CoinsWithTooltip(_ref3) {
  var points = _ref3.points;
  return /*#__PURE__*/_jsx(Translation, {
    "data-element": "Translation",
    "data-component": "CoinsWithTooltip",
    "data-source-file": "reward-card.tsx",
    children: function children(t) {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: t('pointsRequiredText', {
          count: points
        }),
        arrow: true,
        children: /*#__PURE__*/_jsx(Box, {
          sx: {
            zIndex: 1,
            width: 'fit-content'
          },
          children: /*#__PURE__*/_jsx(Coins, {
            points: points
          })
        })
      });
    }
  });
};

export var RewardPoints = function RewardPoints(_ref4) {
  var points = _ref4.points,
      currentPoints = _ref4.currentPoints;
  return currentPoints >= points ? /*#__PURE__*/_jsx(CoinsWithTooltip, {
    points: points
  }) : /*#__PURE__*/_jsxs(Box, {
    sx: {
      width: 1,
      zIndex: 1
    },
    children: [/*#__PURE__*/_jsx(CoinsWithTooltip, {
      points: points
    }), /*#__PURE__*/_jsx(Translation, {
      children: function children(t) {
        return /*#__PURE__*/_jsx(Tooltip, {
          title: t('{{computedPoints}} more points required', {
            computedPoints: formatPoints(points - currentPoints)
          }),
          arrow: true,
          children: /*#__PURE__*/_jsx(ProgressBar, {
            sx: {
              mt: 1
            },
            progress: points <= 0 ? 0 : currentPoints / points * 100
          })
        });
      }
    })]
  });
};

var hasPerks = function hasPerks(perksCount) {
  return perksCount > 0;
};

var RewardCardChip = function RewardCardChip(_ref5) {
  var icon = _ref5.icon,
      label = _ref5.label,
      sx = _ref5.sx;
  return /*#__PURE__*/_jsx(Chip, {
    sx: mergeSxProps({
      position: 'absolute',
      top: 8,
      right: 8,
      fontWeight: function fontWeight(t) {
        return t.typography.fontWeightBold;
      }
    }, sx),
    icon: icon,
    color: "primary",
    label: label,
    "data-element": "Chip",
    "data-component": "RewardCardChip",
    "data-source-file": "reward-card.tsx"
  });
};

var RewardCard = function RewardCard(_ref6) {
  var reward = _ref6.reward,
      linkTo = _ref6.linkTo,
      _ref6$profile = _ref6.profile,
      profileId = _ref6$profile.id,
      isAdmin = _ref6$profile.isAdmin,
      shippingAddress = _ref6$profile.shippingAddress,
      currentPoints = _ref6$profile.currentPoints,
      queriesToRefetchOnRedeem = _ref6.queriesToRefetchOnRedeem;
  var id = reward.id,
      name = reward.name,
      image = reward.image,
      points = reward.points,
      category = reward.category,
      featured = reward.featured,
      onWishList = reward.onWishList;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var hasPerk = hasPerks(reward.perksCount);
  var canRedeem = hasPerk || currentPoints >= reward.points;
  return /*#__PURE__*/_jsxs(ResizableCard, {
    withWiggle: hasPerk,
    "data-element": "ResizableCard",
    "data-component": "RewardCard",
    "data-source-file": "reward-card.tsx",
    children: [/*#__PURE__*/_jsxs(Box, {
      sx: {
        position: 'relative'
      },
      "data-element": "Box",
      "data-component": "RewardCard",
      "data-source-file": "reward-card.tsx",
      children: [/*#__PURE__*/_jsx(CardImage, {
        image: image,
        name: name,
        "data-element": "CardImage",
        "data-component": "RewardCard",
        "data-source-file": "reward-card.tsx"
      }), hasPerk ? /*#__PURE__*/_jsx(RewardCardChip, {
        sx: {
          pl: 0.75
        },
        icon: /*#__PURE__*/_jsx(RedeemIcon, {
          sx: {
            width: 16,
            height: 16
          }
        }),
        label: t("You've been gifted")
      }) : featured && /*#__PURE__*/_jsx(RewardCardChip, {
        label: t('Featured')
      })]
    }), /*#__PURE__*/_jsxs(Content, {
      "data-element": "Content",
      "data-source-file": "reward-card.tsx",
      children: [/*#__PURE__*/_jsxs(Box, {
        sx: {
          display: 'flex',
          justifyContent: 'space-between',
          width: 1
        },
        "data-element": "Box",
        "data-source-file": "reward-card.tsx",
        children: [/*#__PURE__*/_jsxs(Box, {
          sx: {
            mr: 2,
            maxHeight: 56
          },
          "data-element": "Box",
          "data-source-file": "reward-card.tsx",
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "subscript",
            "data-element": "Typography",
            "data-source-file": "reward-card.tsx",
            children: category.name
          }), /*#__PURE__*/_jsx(FullCardLink, {
            to: linkTo !== null && linkTo !== void 0 ? linkTo : '',
            "data-element": "FullCardLink",
            "data-source-file": "reward-card.tsx",
            children: /*#__PURE__*/_jsx(TypographyTruncate, {
              sx: {
                maxHeight: 56
              },
              variant: "h4",
              lines: 2,
              "data-element": "TypographyTruncate",
              "data-source-file": "reward-card.tsx",
              children: name
            })
          })]
        }), /*#__PURE__*/_jsx(WishlistButton, {
          sx: {
            mt: 2,
            zIndex: function zIndex(t) {
              return t.zIndex._1;
            }
          },
          id: id,
          onWishList: onWishList,
          iconOnly: true,
          "data-element": "WishlistButton",
          "data-source-file": "reward-card.tsx"
        })]
      }), /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: 'flex',
          width: 1,
          alignItems: 'center',
          justifyContent: 'space-between',
          mt: 1
        },
        "data-element": "Box",
        "data-source-file": "reward-card.tsx",
        children: [hasPerk ? /*#__PURE__*/_jsx(Box, {
          sx: {
            width: 1
          },
          children: /*#__PURE__*/_jsx(Typography, {
            children: t('Free')
          })
        }) : /*#__PURE__*/_jsx(RewardPoints, {
          points: points,
          currentPoints: currentPoints
        }), canRedeem && /*#__PURE__*/_jsx(RewardRedemption, {
          reward: reward,
          currentPoints: currentPoints,
          profileId: profileId,
          canAfford: true,
          isAdmin: isAdmin,
          address: shippingAddress,
          queriesToRefetchOnRedeem: queriesToRefetchOnRedeem
        })]
      })]
    })]
  });
};

export default RewardCard;